import Vuex from "vuex";
import Vue from "vue";

import createPersistedState from 'vuex-persistedstate'
import authModule from "./modules/auth/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
      auth: authModule,
    },
    plugins: [createPersistedState({
      key: 'vuex',
      reducer (val) {
        if(localStorage.token === null) { // val.user.token (your user token for example)
          return {}
        }
        return val
      }
    })]
});
  